import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.FULLSCREEN_LINK}/:id`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/FullScreenLinkContainer'),
      import('./reducers')
    ])
    injectReducer(store, { key: 'fullscreenLink', reducer: reducer.default })

    cb(null, module.default)
  }
})
